import { type ComponentProps, memo } from 'react';

export type MobileAssetModalPanelProps = Pick<ComponentProps<'div'>, 'children'>;

export const MobileAssetModalPanel = memo(({ children }: MobileAssetModalPanelProps) => {
  return <section className="flex size-full flex-col">{children}</section>;
});

MobileAssetModalPanel.displayName = 'MobileAssetModalPanel';
